const PERMISSIONS_WALLET_PAGE = {
  VIEW: 'voucher_fulfillment_wallet::get',
} as const;

export const REQUIRED_PERMISSIONS = [PERMISSIONS_WALLET_PAGE.VIEW] as const;

export type WalletPagePermissionKey = (typeof REQUIRED_PERMISSIONS)[number];

export default PERMISSIONS_WALLET_PAGE;